import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const { id, currentStatus, steps } = {
  id: null,
  currentStatus: 'new',
  steps: {
    intro: {
      step: 'Giriş Bilgileri',
      email: null,
      phoneNumber: null,
      companyName: null,
      isCompleted: false,
      location: {
        type: 'billing',
        country: {
          code: 'TR',
          title: {
            tr: 'TÜRKİYE',
            en: 'TURKEY',
          },
        },
        city: null,
        county: null,
        district: null,
        zipCode: null,
        street: null,
        geoLocation: {
          latitude: 38.963745,
          longitude: 35.243322,
        },
      },
      photos: [],
      questions: [],
    },
    questions: {
      step: 'Sizi Tanıyalım',
      location: {
        type: 'billing',
        country: {
          code: 'TR',
          title: {
            tr: 'TÜRKİYE',
            en: 'TURKEY',
          },
        },
        city: null,
        county: null,
        district: null,
        zipCode: null,
        street: null,
        geoLocation: {
          latitude: 38.963745,
          longitude: 35.243322,
        },
      },
      photos: [],
      questions: [],
      isCompleted: false,
    },
    companyInformation: {
      step: 'Firma Bilgileri',
      taxInfo: {
        officialName: null,
        tin: null,
        taxOffice: null,
      },
      webSiteUrl: null,
      isCompleted: false,
    },
    contactInformation: {
      step: 'İletişim Bilgileri',
      contacts: [
        {
          name: null,
          title: {
            tr: null,
          },
          email: null,
          phone: null,
        },
      ],
      isCompleted: false,
    },
    contract: {
      step: 'Sözleşme',
      contractDocumentUrl: process.env.VUE_APP_SELLER_CONTRACT_URL,
      bankAccounts: [
        {
          primary: true,
          name: null,
          iban: null,
        },
      ],
      contractMedias: [],
      taxMedias: [],
      commercialRegistrationMedias: [],
      chamberRegistrationMedias: [],
      signatureCircularMedias: [],
      isCompleted: false,
    },
  },
};

export default {
  namespaced: true,
  state: {
    defaultSteps: steps,
    savedApplicationId: localStorage.getItem('savedSellerApplicationId'),
    id,
    currentStatus,
    ...steps,
  },
  actions,
  getters,
  mutations,
};
